import styled from 'styled-components';

import { colorsPalettes, setFontVariant } from '@similarweb/styles';

export const StyledContactNoDetails = styled.div`
  ${setFontVariant('tab', colorsPalettes.carbon[200])};
  font-size: 12px;
`;
